export enum ElevationLevel {
  Small = "SMALL",
  Medium = "MEDIUM",
  Large = "LARGE",
}
